import { useQuery } from '@tanstack/react-query';
import type { Line } from '@chatapp-inbox/shared';
import { listLines } from '../../api';
import { linesKey } from './keys';

/**
 * Os números de WhatsApp ligados. É informação de APOIO (mostrar em que número a conversa acontece):
 * se a consulta falhar, `data` fica indefinido e quem usa segue sem ela, sem erro na tela. O 4xx/5xx
 * não é repetido à toa (a política padrão do cliente já cuida disso).
 */
export function useLines() {
  return useQuery({ queryKey: linesKey, queryFn: ({ signal }) => listLines(signal) });
}

/** Só os ligados: o contrato já devolve só eles, mas a lista é a que a interface decide mostrar. */
export const enabledLines = (lines: readonly Line[] | undefined): Line[] =>
  (lines ?? []).filter((line) => line.enabled);

/**
 * Horas da janela de resposta do número de uma conversa, ou `null` (número desconhecido da lista,
 * por exemplo desligado, ou sem regra). Quem usa trata `null` sem citar prazo.
 */
export function replyWindowHoursOf(
  lines: readonly Line[] | undefined,
  lineId: string | null | undefined,
): number | null {
  if (!lineId) return null;
  return lines?.find((line) => line.id === lineId)?.replyWindowHours ?? null;
}
